<script setup>
import ActionMessage from "@Components/ActionMessage.vue";
import { PrimaryButton } from "@Components/Button";
import Badge from "@Components/Badge.vue";
import { useSlots } from "vue";
import { useI18n } from "vue-i18n";

const slots = useSlots();
const { t: __ } = useI18n();

defineProps({
    icon: Object,
    required: Boolean,
    recommended: Boolean,
    optional: Boolean,
    comingSoon: Boolean,
    form: Object,
});

defineEmits(["submit"]);
</script>

<template>
    <form @submit.prevent="$emit('submit')">
        <div class="h-full relative flex bg-white rounded-lg ring-1 ring-gray-300 shadow dark:bg-gray-950 dark:ring-gray-800">
            <div class="flex flex-col flex-1 px-4 py-5 sm:p-6">
                <component :is="icon" class="w-10 h-10 inline-flex items-center mb-4 text-gray-900 pointer-events-none dark:text-white" />
                <div v-if="required" class="absolute top-2 right-2 text-xs text-gray-600 dark:text-gray-400">
                    <span class="text-sm text-red-500">*</span> {{ __("Requis") }}
                </div>
                <div v-else-if="recommended" class="absolute top-2 right-2 text-xs text-gray-600 dark:text-gray-400">{{ __("Recommandé") }}</div>
                <div v-else-if="optional" class="absolute top-2 right-2 text-xs text-gray-600 dark:text-gray-400">{{ __("Optionnel") }}</div>
                <Badge v-else-if="comingSoon" color="yellow" class="absolute top-2 right-2">{{ __("Coming Soon") }}</Badge>

                <p class="my-0 text-base font-semibold text-gray-900 dark:text-white">
                    <slot name="title"></slot>
                </p>

                <p v-if="!!slots.description" class="mt-1 mb-0 text-sm text-gray-600 dark:text-gray-400">
                    <slot name="description"></slot>
                </p>

                <div v-if="!!slots.form" class="my-6 space-y-6 break-all">
                    <slot name="form"></slot>
                </div>

                <div v-if="!!slots.footer" class="mt-auto flex justify-end items-center">
                    <slot name="footer" />
                </div>
                <div v-else-if="form" class="mt-auto flex justify-end items-center">
                    <ActionMessage :on="form.recentlySuccessful" class="mr-3"> {{ __("Sauvegardé.") }} </ActionMessage>
                    <PrimaryButton :processing="form.processing"> {{ __("Sauvegarder") }} </PrimaryButton>
                </div>
            </div>
        </div>
    </form>
</template>
